import { Alert, Snackbar } from "@mui/material";

function ShowNotif({ isShow, actionClose, data }) {
    return (
        <>
            <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={isShow} onClose={actionClose} autoHideDuration={3000}>
                <Alert variant="filled" sx={{ width: '100%' }} severity={data?.status}>{data?.message}</Alert>
            </Snackbar>
        </>
    )
}

export default ShowNotif;